'use client';

import Link from 'next/link';
import { c } from '../../../utils/tailwind-merge';
import { Button } from '../../atoms/Button/Button';
import { LinkButton } from '../../atoms/Link/LinkButton';
import { Modal } from '../../molecules/Modal/Modal';
import { useModal } from '../../molecules/Modal/useModal';
import { RichText } from '../../molecules/RichText/RichText';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../molecules/Table/Table';
import { LicensingTableProps } from './LicensingTable.types';

export const LicensingTable = ({
  termsOfServiceLink,
  customAgreement,
  microcopy,
  className = '',
}: LicensingTableProps) => {
  const [isActive, toggle] = useModal();

  const richTextLinkStyles = c(
    'tiny-text break-normal text-black',
    '[&_a]:tiny-text-link [&_a]:text-blue [&_a]:no-underline [&_a:visited]:tiny-text-link',
    '[&_div]:tiny-text-link [&_div]:text-blue [&_div]:no-underline [&_div:visited]:tiny-text-link'
  );

  return (
    <Table className={className}>
      <TableCaption>{microcopy.title}</TableCaption>

      <TableHeader className="sr-only">
        <TableRow>
          <TableHead>{microcopy.headerColumn1}</TableHead>
          <TableHead>{microcopy.headerColumn2}</TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        <TableRow>
          <TableHead scope="row">{microcopy.licenseAgreement}</TableHead>
          <TableCell>
            <Link href={termsOfServiceLink} className="tiny-text text-blue">
              {customAgreement ? customAgreement : microcopy.standardEula}
            </Link>
          </TableCell>
        </TableRow>
        {!customAgreement ? (
          <TableRow>
            <TableHead scope="row">{microcopy.licenseType}</TableHead>
            <TableCell
              className={c(
                'break-normal [&_a]:no-underline [&_span]:w-full [&_span]:no-underline',
                className
              )}
            >
              <LinkButton
                className={c(
                  'inline-block text-balance font-normal capitalize text-blue',
                  className
                )}
                onClick={(e) => {
                  e?.preventDefault();
                  toggle();
                }}
                aria-expanded={isActive}
                label={microcopy.extensionAsset}
                href={'#'}
              />

              <div>
                <Modal
                  title={microcopy.extensionAssetTitle}
                  closeLabel={microcopy.extensionAssetClose}
                  isActive={isActive}
                  closeModal={toggle}
                  titleClassName={c('!mx-11')}
                  actions={
                    <div className="flex gap-2">
                      <Button
                        label={microcopy.extensionAssetClose}
                        onClick={toggle}
                        style="secondary"
                      />
                    </div>
                  }
                  actionsSide="right"
                >
                  <RichText
                    html={microcopy.extensionAssetDescription}
                    className={c(richTextLinkStyles, 'mx-11 text-left')}
                  />
                </Modal>
              </div>
            </TableCell>
          </TableRow>
        ) : null}
      </TableBody>
    </Table>
  );
};
